export default __webpack_public_path__ + "static/media/7.21524449.png";